/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Career } from '../../models/career';
import { CriteriaContentObject } from '../../models/criteria-content-object';

export interface ApiMasterCareerGetByCriteriaPost$Params {
      body?: CriteriaContentObject
}

export function apiMasterCareerGetByCriteriaPost(http: HttpClient, rootUrl: string, params?: ApiMasterCareerGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Career>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterCareerGetByCriteriaPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Career>>;
    })
  );
}

apiMasterCareerGetByCriteriaPost.PATH = '/api/Master/Career/GetByCriteria';
